'use strict';

import '../../css/fields/login-field.scss';
import { loginFieldElements } from "./elements/loginFieldElements";

export default class LoginField
{
    constructor() {
        this.elements = loginFieldElements();
        this.loginToggleDown = this.onLoginToggleDown.bind(this);
        this.closeDown = this.onCloseDown.bind(this);
        this.addEventListeners();
    }

    addEventListeners() {
        if (this.elements.closeButton !== null) {
            for (let closeButton of this.elements.closeButton) {
                closeButton.addEventListener('mousedown', this.closeDown);
            }
        }
        if (this.elements.loginButton !== null) {
            this.elements.loginButton.addEventListener('mousedown', this.loginToggleDown);
        }
    }

    onLoginToggleDown(event) {
        event.preventDefault();
        if (this.elements.formContainer.classList.contains('hidden')) {
            this.elements.formContainer.classList.remove('hidden');
            this.elements.loginButton.classList.add('opened');
            this.elements.inputLoginName.disabled = false;
            this.elements.inputPassword.disabled = false;
            this.elements.inputLoginName.focus();
        } else {
            this.elements.inputLoginName.disabled = true;
            this.elements.inputPassword.disabled = true;
            this.elements.formContainer.classList.add('hidden');
            this.elements.loginButton.classList.remove('opened');
        }
    }

    onCloseDown(event) {
        event.preventDefault();
        if (!this.elements.formContainer.classList.contains('hidden')) {
            this.elements.inputLoginName.disabled = true;
            this.elements.inputPassword.disabled = true;
            this.elements.formContainer.classList.add('hidden');
        }
        if (this.elements.loggedInContainer !== null) {
            this.elements.loggedInContainer.classList.add('hidden');
            window.history.pushState({}, null, '/');
        }
    }
}
